module.exports = __webpack_public_path__ + "fonts/mc.830b682.woff";